<template>
  <p class="flex items-center justify-between pb-3 text-gray-700">
    <span class="flex items-center w-full">
      <svg class="mr-3" style="height: 1em; width: 1em;" focusable="false" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>
      {{ name }}
    </span>

    <span :class="['block w-1/6 text-right text-sm', { 'text-red-600': isTooBig }]">{{ sizeInKb }}kb</span>
  
    <span class="flex items-center w-2/6">
      <button v-show="!completed" @click="$emit('remove')" class="hover:text-red-600 disabled:text-gray-200 text-lg outline-none ml-auto" :disabled="completed || uploading || (uploaded && !completed)">
        <svg style="height: 1em; width: 1em;" focusable="false" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
      </button>
      <a :href="downloadUrl" download v-show="completed" class="hover:text-green-600 text-lg outline-none ml-auto">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
      </a>
    </span>
  </p>
</template>

<script>
export default {
  props: {
    name: String,
    type: String,
    size: Number,
    uploading: Boolean,
    uploaded: Boolean,
    completed: Boolean,
    downloadUrl: String
  },
  computed: {
    sizeInKb() {
      return Math.floor(this.size / 1024) 
    },
    isTooBig() {
      return this.sizeInKb > 5120;
    }
  }
}
</script>